import React, { ReactNode } from 'react';
import { clamp } from 'lodash';
import { Icon } from '@zapier/common-components';
import { buildCommonComponent } from '@zapier/legacy-components';
import { useHeadingLevel } from '@zapier/common-utils';
import './Heading.scss';
import { suffixes } from 'bemify-js';
const buildHeading = buildCommonComponent('generic-heading');
const headingComponents = [
  buildHeading(null, 'h1'),
  buildHeading(null, 'h2'),
  buildHeading(null, 'h3'),
  buildHeading(null, 'h4'),
  buildHeading(null, 'h5'),
  buildHeading(null, 'h6'),
];
export const [
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
] = headingComponents;
export const HeadingIcon = buildHeading('__icon', Icon);
type Props = {
  kind?: typeof suffixes;
  children: ReactNode;
  [x: string]: any;
};
export const SectionHeading = ({ kind, ...props }: Props) => (
  <Heading2 kind={['bold 20 1-em-bottom flex', kind]} {...props}>
    {props.children}
  </Heading2>
);
export function Heading({ children, kind, className }: Props) {
  const { level } = useHeadingLevel();
  const headingLevel = clamp(level, 1, 6);
  const HeadingComponent = headingComponents[headingLevel - 1];
  return (
    <HeadingComponent className={className} kind={kind}>
      {children}
    </HeadingComponent>
  );
}
